export default "__VITE_ASSET__148c1RiM__"